import {AlertType} from "../enums/alert-type.enum";

export interface PrescriptionAlert {
  productId: number,
  alertCount: number,
  alertType: AlertType,
  linkedIds?: number[],
  hasSam?: boolean,
  patientEligibility?: boolean,
  alertsByLvl?: {
    contraindicationLvl3?: number,
    contraindicationLvl4?: number,
    interactionsLv1?: number,
    interactionsLv2?: number,
    interactionsLv3?: number,
    interactionsLv4?: number
  },
  posologyLevel?: string
}

export interface PrescriptionAlerts {
  interactionsLv1: PrescriptionAlert[],
  interactionsLv2: PrescriptionAlert[],
  interactionsLv3: PrescriptionAlert[],
  interactionsLv4: PrescriptionAlert[],
  surdosages: PrescriptionAlert[],
  redondances_composant: PrescriptionAlert[],
  redondances_classe: PrescriptionAlert[],
  precautions_emploi: PrescriptionAlert[],
  contre_indicationsLv3: PrescriptionAlert[],
  contre_indicationsLv4: PrescriptionAlert[],
  allergies: PrescriptionAlert[],
  posologies: PrescriptionAlert[],
  sam: PrescriptionAlert[],
  stopp: PrescriptionAlert[],
  ipc: PrescriptionAlert[]
}

export interface PrescriptionAlertsVisibility {
  interactionsLv1: boolean,
  interactionsLv2: boolean,
  interactionsLv3: boolean,
  interactionsLv4: boolean,
  surdosages: boolean,
  redondances_composant: boolean,
  redondances_classe: boolean,
  precautions_emploi: boolean,
  contre_indicationsLv3: boolean,
  contre_indicationsLv4: boolean,
  allergies: boolean,
  stopp: boolean,
  sam: boolean,
  posologies: boolean,
  ipc: boolean
}

export interface PrescriptionAlertsCounter {
  interactions: number,
  interactionsLv1: number,
  interactionsLv2: number,
  interactionsLv3: number,
  interactionsLv4: number,
  interactionsHidden: number,
  redondances: number,
  redondancesHidden: number,
  precautionsEmploi: number,
  precautionsEmploiHidden: number,
  contreIndications: number,
  contreIndicationsHidden: number,
  allergies: number,
  allergiesHidden: number,
  stopp: number,
  stoppHidden: number,
  posologies: number
  posologiesHidden: number
  ipc: number,
  ipcHidden: number
}

export interface PrescriptionAlertResponse {
  prescriptionAlerts: PrescriptionAlert[];
  stoppAlerts: StoppAlert[];
}

export interface SamAlert {
  productId: number;
  hasSam: boolean;
  patientEligibility: boolean;
  type: number;
}

export interface StoppAlert {
  productId: number,
  therapeuticClass: TherapeuticClass[],
  stoppId: number,
  stoppDescription: string,
  stoppLevel: number,
  stoppMessage: string
}

export interface TherapeuticClass {
  code: string,
  label: string
}
